import * as tools from '../utils/tools';
import * as tests from '../utils/tests';

const state = {};
const instances = {};
const browsers = tests.browserTests();

/**
 * @function fitVideoToContainer
 * @description Background size cover implementation for any el, applied to the video
 */

const fitVideoToContainer = (id) => {
	const container = tools.getNodes(`#${id}`, false, document, true)[0];
	if (!container) {
		return;
	}
	const template = tools.getNodes(`[data-id="${id}"]`, false, document, true)[0];
	const video = tools.getNodes('video', false, container, true)[0];
	const w = parseInt(template.dataset.width, 10);
	const h = parseInt(template.dataset.height, 10);
	const dH = container.offsetHeight;
	const dW = container.offsetWidth;

	let sW = (dH / h) * w;
	sW = (sW >= dW) ? sW : dW;

	let sH = dH;
	if (sW === dW) {
		sH = (dW / w) * h;
	}

	const left = sW === dW ? 0 : -(Math.abs(sW - dW) / 2);

	video.style.width = `${sW}px`;
	video.style.height = `${sH}px`;
	video.style.left = `${left}px`;
};

/**
 * @function resizeBGVideo
 * @description resize the bg vids
 */

const resizeBGVideo = video => fitVideoToContainer(video.dataset.id);

/**
 * @function revealVideo
 * @description Crossfade video with video poster
 */

const revealVideo = (id) => {
	const container = tools.getNodes(`#${id}`, false, document, true)[0];
	const wrapper = tools.closest(container, '.et_pb_section_video_bg_brightcove');
	wrapper.classList.remove('loading');
};

const videoIsPlaying = video => !(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);

/**
 * @function playVideo
 * @description After the supplied bc script has loaded, kickoff the init to get the video looping and reveal the
 * player
 */

const playVideo = (videoId) => {
	instances[videoId] = window.videojs(videoId, {});

	instances[videoId].on('loadedmetadata', () => {
		fitVideoToContainer(videoId);
		revealVideo(videoId);
	});

	if (!videoIsPlaying(instances[videoId])) {
		instances[videoId].play();
	}
};

/**
 * @function initVideo
 * @description Inject the script tag for a bc video and grab its custom script to inject
 */

const initVideo = (video) => {
	const script = document.createElement('script');
	video.insertAdjacentHTML('afterend', video.innerHTML);
	script.src = video.dataset.src;
	document.body.appendChild(script);
	state.currentPlayerID = video.dataset.id;
	script.onload = () => {
		playVideo(video.dataset.id);
	};
};

/**
 * @function findBGVideos
 * @description
 */

const findBGVideos = () => tools.getNodes('bc-bg-video', true).forEach(video => initVideo(video));

/**
 * @function findBGVideos
 * @description
 */

const resizeBGVideos = () => tools.getNodes('bc-bg-video', true).forEach(video => resizeBGVideo(video));

/**
 * @function executeResize
 * @description
 */

const executeResize = () => {
	resizeBGVideos();
};

const bindEvents = () => {
	document.addEventListener('modern_tribe/resize_executed', executeResize);
};

/**
 * @function init
 * @description Kick off this modules functions. Do not load for mobiles
 */

const init = () => {
	if (browsers.iosMobile || browsers.android) {
		return;
	}
	findBGVideos();
	bindEvents();
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/bg-video.js